/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1BankIdImage200,
  PostApiV1BankIdImage400,
  PostApiV1BankIdImage401,
  PostApiV1BankIdImage404,
  PostApiV1BankIdImage500,
  PostApiV1BankIdImageMutationRequest,
  PostApiV1BankIdImageMutationResponse,
  PostApiV1BankIdImagePathParams,
} from "../../types/bankImagemController/PostApiV1BankIdImage.ts";

export const postApiV1BankIdImagePathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1BankIdImagePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1BankIdImage200Schema =
  z.any() as unknown as ToZod<PostApiV1BankIdImage200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1BankIdImage400Schema =
  z.any() as unknown as ToZod<PostApiV1BankIdImage400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1BankIdImage401Schema =
  z.any() as unknown as ToZod<PostApiV1BankIdImage401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1BankIdImage404Schema =
  z.any() as unknown as ToZod<PostApiV1BankIdImage404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1BankIdImage500Schema =
  z.any() as unknown as ToZod<PostApiV1BankIdImage500>;

export const postApiV1BankIdImageMutationRequestSchema = z.object({
  file: z.optional(z.instanceof(File)),
}) as unknown as ToZod<PostApiV1BankIdImageMutationRequest>;

export const postApiV1BankIdImageMutationResponseSchema = z.lazy(
  () => postApiV1BankIdImage200Schema,
) as unknown as ToZod<PostApiV1BankIdImageMutationResponse>;
